'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _predicates = require('../internal/predicates');

exports.default = function (thing) {
  return (0, _predicates.isIndexed)(thing) || Array.isArray(thing);
};


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/util/isIndexed.js
// module id = 196
// module chunks = 35783957827783